import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import 'react';
import { themed, getDefaultThemedOptions } from '@indeed/ifl-css';
import { useDialogContext } from './context.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';

const dialogBackdropBaseStyles = _ref => {
  let {
    type
  } = _ref;
  return {
    bg: type === "popup" ? "transparent" : "utility.overlay",
    blockSize: "100%",
    left: "0",
    position: "fixed",
    top: "0",
    inlineSize: "100%",
    zIndex: 1
  };
};
const StyledDialogBackdrop = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? _extends({}, {
  target: "e1nenfmp0"
}, getDefaultThemedOptions("type")) : _extends({}, {
  target: "e1nenfmp0",
  label: "StyledDialogBackdrop"
}, getDefaultThemedOptions("type")))(dialogBackdropBaseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRpYWxvZ0JhY2tkcm9wLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQm9DIiwiZmlsZSI6IkRpYWxvZ0JhY2tkcm9wLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGQyB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHtcbiAgU3lzdGVtU3R5bGVPYmplY3QsXG4gIHRoZW1lZCxcbiAgZ2V0RGVmYXVsdFRoZW1lZE9wdGlvbnNcbn0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuaW1wb3J0IHsgdXNlRGlhbG9nQ29udGV4dCwgRGlhbG9nQ29udGV4dFZhbHVlIH0gZnJvbSBcIi4vY29udGV4dFwiO1xuXG50eXBlIFN0eWxlZERpYWxvZ0JhY2tkcm9wUHJvcHMgPSBQaWNrPERpYWxvZ0NvbnRleHRWYWx1ZSwgXCJ0eXBlXCI+O1xuXG5leHBvcnQgY29uc3QgZGlhbG9nQmFja2Ryb3BCYXNlU3R5bGVzID0gKHtcbiAgdHlwZVxufTogU3R5bGVkRGlhbG9nQmFja2Ryb3BQcm9wcyk6IFN5c3RlbVN0eWxlT2JqZWN0ID0+ICh7XG4gIGJnOiB0eXBlID09PSBcInBvcHVwXCIgPyBcInRyYW5zcGFyZW50XCIgOiBcInV0aWxpdHkub3ZlcmxheVwiLFxuICBibG9ja1NpemU6IFwiMTAwJVwiLFxuICBsZWZ0OiBcIjBcIixcbiAgcG9zaXRpb246IFwiZml4ZWRcIixcbiAgdG9wOiBcIjBcIixcbiAgaW5saW5lU2l6ZTogXCIxMDAlXCIsXG4gIHpJbmRleDogMVxufSk7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dCYWNrZHJvcCA9IHRoZW1lZChcbiAgXCJkaXZcIixcbiAgZ2V0RGVmYXVsdFRoZW1lZE9wdGlvbnMoXCJ0eXBlXCIpXG4pPFN0eWxlZERpYWxvZ0JhY2tkcm9wUHJvcHM+KGRpYWxvZ0JhY2tkcm9wQmFzZVN0eWxlcyk7XG5cbmV4cG9ydCBjb25zdCBEaWFsb2dCYWNrZHJvcDogRkMgPSAoeyAuLi5yZW1haW5pbmdQcm9wcyB9KSA9PiB7XG4gIGNvbnN0IHsgaXNPcGVuLCBzZXRPcGVuLCB0eXBlIH0gPSB1c2VEaWFsb2dDb250ZXh0KCk7XG5cbiAgY29uc3QgaGFuZGxlT25DbGljayA9ICgpOiB2b2lkID0+IHtcbiAgICBpZiAodHlwZSAhPT0gXCJhbGVydGRpYWxvZ1wiKSB7XG4gICAgICBzZXRPcGVuKCFpc09wZW4pO1xuICAgIH1cbiAgfTtcblxuICByZXR1cm4gKFxuICAgIDxTdHlsZWREaWFsb2dCYWNrZHJvcFxuICAgICAgb25DbGljaz17aGFuZGxlT25DbGlja31cbiAgICAgIHR5cGU9e3R5cGV9XG4gICAgICB7Li4ucmVtYWluaW5nUHJvcHN9XG4gICAgLz5cbiAgKTtcbn07XG5cbkRpYWxvZ0JhY2tkcm9wLmRpc3BsYXlOYW1lID0gXCJEaWFsb2dCYWNrZHJvcFwiO1xuIl19 */");
const DialogBackdrop = _ref2 => {
  let {
    ...remainingProps
  } = _ref2;
  const {
    isOpen,
    setOpen,
    type
  } = useDialogContext();
  const handleOnClick = () => {
    if (type !== "alertdialog") {
      setOpen(!isOpen);
    }
  };
  return jsx(StyledDialogBackdrop, _extends({
    onClick: handleOnClick,
    type: type
  }, remainingProps));
};
DialogBackdrop.displayName = "DialogBackdrop";

export { DialogBackdrop, StyledDialogBackdrop, dialogBackdropBaseStyles };
